import Dies from '@/models/Dies/Dies';

export default class DiesFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.code = '';
		this.name = '';
		this.diesLong = '';
		this.wide = '';
		this.height = '';
		this.standarPreventive = '';
		this.uomId  = '';
		this.uomCode = '';
		this.remarkMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			code : '0',
			name : '0',
			diesLong : '0',
			wide : '0',
			height : '0',
			standarPreventive : '0',
			uomId : '0',
			uomCode : '0',
			remarkMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}